import validators from '../../utils/validators';
import QuestionnaireQuestion from './question';

class QuestionnaireCategory {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      title: (v) => validators.isNotEmptyString(v),
      description: (v) => validators.isNotEmptyStringOrNull(v),
      sort: (v) => validators.isNumber(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid QuestionnaireCategory property '${property}' in ${data.id}`);
      }

      this[property] = data[property];
    }

    this.questions = [];

    if (Array.isArray(data.questions)) {
      for(const question of data.questions) {
        this.questions.push(new QuestionnaireQuestion(question));
      }
    }
  }
}

export default QuestionnaireCategory;
